/* KAECE · Speak to the team · 01.11.26. The drawer in snippets/kaece-contact.liquid.
   Opens from [data-kct-open] (optional data-kct-topic="Private fitting") and from any team@kaece.co email link on the site:
   the link's subject picks the topic. The plain email link inside the drawer stays an email link. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kct]'); if (!root) return;
  var wash = document.querySelector('[data-kct-wash]'), last = null;
  var TOPICS = { fitting: 'Private fitting', measure: 'Made to measure', partner: 'Partners', press: 'Press', size: 'Sizing and fit', order: 'Order', allocation: 'Order' };
  function pick(t) {
    if (!t) return;
    var low = String(t).toLowerCase(), want = null;
    [].forEach.call(root.querySelectorAll('[data-kct-topic]'), function (r) { if (r.value.toLowerCase() === low) want = r; });
    if (!want) Object.keys(TOPICS).forEach(function (k) { if (!want && low.indexOf(k) > -1) want = root.querySelector('[data-kct-topic][value="' + TOPICS[k] + '"]'); });
    if (want) { want.checked = true; order(); }
  }
  function order() {
    var on = root.querySelector('[data-kct-topic]:checked'), box = root.querySelector('[data-kct-order]');
    if (box) box.hidden = !(on && on.value === 'Order');
  }
  function open(topic) {
    last = document.activeElement;
    var page = root.querySelector('[data-kct-page]'); if (page) page.value = location.pathname;
    pick(topic);
    if (wash) wash.classList.add('is-open');
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kct-lock');
    setTimeout(function () { var f = root.querySelector('[data-kct-topic]:checked') ? root.querySelector('input[name="contact[name]"]') : root.querySelector('[data-kct-topic]'); if (f) f.focus({ preventScroll: true }); }, 420);
  }
  function close() {
    if (wash) wash.classList.remove('is-open');
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kct-lock');
    if (last && last.focus) last.focus({ preventScroll: true });
  }
  root.addEventListener('change', function (e) { if (e.target.matches('[data-kct-topic]')) order(); });
  root.addEventListener('click', function (e) { if (e.target.closest('[data-kct-close]')) { e.preventDefault(); close(); } });
  if (wash) wash.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kct-open], a[href^="mailto:team@kaece.co"]');
    if (!a || a.hasAttribute('data-kct-mail') || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    var topic = a.getAttribute('data-kct-topic');
    if (!topic && a.href) { var m = a.href.match(/[?&]subject=([^&]+)/i); if (m) { try { topic = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (x) {} } }
    open(topic);
  });
  window.KAECE_CONTACT = { open: open, close: close };
  var state = root.getAttribute('data-kct-state');
  if (state === 'sent' || state === 'error' || /[?&]contact_posted=true/.test(location.search)) setTimeout(function () { open(); }, 300);
})();
